import React from 'react';
import { KeyedMutator } from 'swr';
import ReactSelect from 'react-select';
import { Controller, useForm } from 'react-hook-form';
import { CleanUser } from '../../../export-types/cleaned-types';
import { ModalProps } from '../../../services/modals.service';
import { useModalClose } from '../../../utils/useModalClose';
import { api } from '../../../services/api';
import { AlertService } from '../../../services/alert.service';
import { required } from '../../../utils/validations';
import { InputWrapper } from '../../common/input-wrapper';

type UnlinkObserverModalProps = ModalProps & {
  user: CleanUser;
  mutate?: KeyedMutator<any>;
};

export const UnlinkObserverModal = ({
  user,
  close,
  mutate,
}: UnlinkObserverModalProps) => {
  const modalRef = useModalClose(close);
  const { control, handleSubmit } = useForm<{ observer: CleanUser }>({
    defaultValues: { observer: user.observers?.[0] },
  });

  const onSubmit = handleSubmit(async ({ observer }) => {
    try {
      await api.post(`/user/${user.id}/observers/${observer.id}/unlink`);
      AlertService.success();
      mutate?.();
      close();
    } catch (error: any) {
      AlertService.error(error?.message);
    }
  });

  return (
    <div className="modal-dialog mw-400" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4">
          <button type="button" className="btn-close" onClick={close} />
        </div>
        <div className="modal-body pt-2 p-4">
          <h3 className="text-center mb-4">Снять наблюдателя с клиента</h3>
          <form onSubmit={onSubmit}>
            <Controller
              control={control}
              name="observer"
              rules={{ ...required }}
              render={({ field, fieldState }) => (
                <InputWrapper
                  className="mb-3 text-start"
                  title="Наблюдатель"
                  required
                  error={fieldState.error?.message}
                >
                  <ReactSelect
                    options={user.observers ?? []}
                    getOptionLabel={(observer) => observer.name ?? observer.id}
                    getOptionValue={(observer) => observer.id}
                    onChange={field.onChange}
                    value={field.value}
                  />
                </InputWrapper>
              )}
            />
            <button type="submit" className="btn btn-success w-100 mb-3">
              Снять наблюдателя
            </button>
            <button
              type="button"
              className="btn btn-light w-100"
              onClick={close}
            >
              Отменить
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
